const BLOCKING_INKLESS_ERROR = (
  /could not tell which side you represent|e-signing is not supported|starter PDF|cannot be sent for e-sign|supports at most \d+ (buyers|sellers)/i
);

const PROTECTED_VENDOR_ROLES = new Set([
  'title',
  'title_officer',
  'escrow',
  'escrow_officer',
  'closer',
  'closing_officer',
  'escrow_closer',
  'insurance',
  'insurance_agent',
]);

export function isProtectedTeamRole(role) {
  const normalized = String(role || '')
    .trim()
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  if (PROTECTED_VENDOR_ROLES.has(normalized)) return true;
  if (normalized.includes('referring')) return false;

  const isTc = (
    normalized === 'tc'
    || normalized.endsWith('_tc')
    || normalized.includes('transaction_coordinator')
  );
  if (normalized === 'tc' || normalized === 'transaction_coordinator') return true;

  const isBuyerSide = normalized.includes('buyer');
  const isSellerSide = normalized.includes('seller') || normalized.includes('listing');
  if (isBuyerSide) {
    return isTc || normalized.includes('agent') || normalized.includes('broker');
  }
  if (isSellerSide) {
    return isTc || normalized.includes('agent');
  }
  return false;
}

export function canEditTransactionTeam({ viewerLoaded, isGuest, canManageTeam }) {
  return viewerLoaded === true && isGuest !== true && canManageTeam === true;
}

export function inklessErrorPreventsSend(error) {
  return BLOCKING_INKLESS_ERROR.test(String(error || ''));
}

export function canAttemptInklessSend({
  viewerLoaded,
  isGuest,
  canSendInkless,
  inklessEligible,
  inklessError,
}) {
  return (
    viewerLoaded === true
    && isGuest !== true
    && canSendInkless === true
    && inklessEligible === true
    && !inklessErrorPreventsSend(inklessError)
  );
}

export function canRecoverSignedDocument({ canReadParent, canMutate }) {
  return canReadParent === true && canMutate === true;
}

export function canAttemptInklessRecovery({ canRecoverInkless, inklessEligible }) {
  return canRecoverInkless === true && inklessEligible === true;
}
